
import { Container, Typography } from "@mui/material";
import AddBannerForm from "../add-form";

export default function BannerAdd() {
    return (
        <Container maxWidth="xl" sx={{ mt: 4 }}>
            <Typography variant="h4" sx={{ mb: 2 }}>Add Banner</Typography>
            <AddBannerForm />
        </Container>
    )
}